<template>
  <div class="invoice-detail-page">
    <a-card title="发票详情" :bordered="false" v-if="invoice">
      <div class="detail-actions">
        <a-button class="btn-cancel" @click="goBack">返回</a-button>
        <a-button class="btn" type="primary" v-if="invoice.status === '0'" @click="refreshResult">刷新申请信息</a-button>
      </div>

      <a-descriptions bordered :column="2">
        <a-descriptions-item label="发票抬头">{{ invoice.gmfMc || '-' }}</a-descriptions-item>
        <a-descriptions-item label="收票邮箱">{{ invoice.gmfEmail || '-' }}</a-descriptions-item>
        <a-descriptions-item label="发票状态">{{ invoice.status_dictText }}</a-descriptions-item>
        <a-descriptions-item label="发票号码">{{ invoice.qdfphm || '-' }}</a-descriptions-item>
        <a-descriptions-item label="开票时间">{{ invoice.kprq || '-' }}</a-descriptions-item>
        <a-descriptions-item label="发票下载" v-if="invoice.status==='1' && (invoice.jfdz || invoice.jfmUrl)">
          <a class="download-link" @click="download">
            <a-icon type="download" />
            点击下载
          </a>
        </a-descriptions-item>
      </a-descriptions>


      <div style="margin-top: 20px">
        <h3>发票明细</h3>
        <a-table
          :columns="detailColumns"
          :data-source="details"
          :pagination="false"
          size="small"
          :row-key="(row, index) => index"
        />
      </div>



      
      <div style="margin-top: 20px">
        <h3>关联订单</h3>
        <a-table
          :columns="orderColumns"
          :data-source="orders"
          :pagination="false"
          size="small"
          :row-key="(row, index) => index"
        >
          <template slot="amount" slot-scope="text">
            <span>{{ text || '-' }}</span>
          </template>
        </a-table>
      </div>
    </a-card>

    <!-- 发票弹出层 -->
    <a-modal
      :visible="invoiceModalVisible"
      :footer="null"
      :width="500"
      title="发票预览"
      @cancel="closeInvoiceModal"
    >
      <iframe
        :src="currentInvoiceUrl"
        style="width: 100%; height: 500px; border: none;"
        frameborder="0"
      ></iframe>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'StudentInvoiceDetail',
  data() {
    return {
      id: '',
      invoice: null,
      details: [],
      orders: [],
      invoiceModalVisible: false,
      currentInvoiceUrl: '',
      orderColumns: [
        { title: '缴费时间', dataIndex: 'orderTime', align: 'center', width: 160 },
        { title: '单据号', dataIndex: 'tradeNo', align: 'center', width: 130 },
        { title: '支付方式', dataIndex: 'tradeChannel', align: 'center', width: 100 },
        { title: '金额', dataIndex: 'amount', align: 'center', width: 100, scopedSlots: { customRender: 'amount' } },
        // { title: '说明', dataIndex: 'remark', align: 'center' },
      ],
      detailColumns: [
        { title: '序号', dataIndex: 'xh', align: 'center' },
        { title: '项目', dataIndex: 'spmc', align: 'center' },
        { title: '税率', dataIndex: 'slv', align: 'center' },
        { title: '金额', dataIndex: 'je', align: 'center' },
        // { title: '税额', dataIndex: 'se', align: 'center' },
        
      ],
    }
  },
  created() {
    this.id = this.$route.query.id || ''
    if (!this.id) {
      this.$message.error('参数缺失')
      this.goBack()
      return
    }
    this.loadDetail()
  },
  methods: {
    goBack() {
      this.$router.push('/personalcenters/invoice/list')
    },
    loadDetail() {
      this.axios.get('/stu/invoice/detail', { params: { id: this.id } }).then((res) => {
        if (res.code !== 200) return
        const result = res.result || {}
        this.invoice = result.invoice || null
        this.orders = result.orders || []
        this.details = result.details || []
        // 对学生的友好展示：1003(需认证)/1004(需登录) 统一显示为申请中
        if (this.invoice && (this.invoice.status === '1003' || this.invoice.status === '1004')) {
          this.invoice.status = '0'
          this.invoice.status_dictText = '申请中'
        }
      })
    },
    refreshResult() {
      this.axios.post('/stu/invoice/queryResultBatch', { invoiceIds: [this.id] }).then((res) => {
        if (res.code === 200) {
          this.$message.success('刷新完成')
          this.loadDetail()
        }
      })
    },
    download() {
      if (this.invoice.jfdz) {
        // 优先使用 jfdz，直接打开新窗口下载
        window.open(this.invoice.jfdz, '_blank')
      } else if (this.invoice.jfmUrl) {
        // 如果是 jfmUrl，使用弹出层显示
        this.showInvoiceModal(this.invoice.jfmUrl)
      } else {
        this.$message.warning('暂无可下载的发票文件')
      }
    },
    showInvoiceModal(url) {
      this.currentInvoiceUrl = url
      this.invoiceModalVisible = true
    },
    closeInvoiceModal() {
      this.invoiceModalVisible = false
      this.currentInvoiceUrl = ''
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'

.btn {
  background: $bgColor !important;
  border: none;
}

.btn-cancel {
  margin-right: 12px;
}

.invoice-detail-page
  background $bgcontent
  min-height 600px
  padding 20px

.detail-actions
  margin-bottom 20px

// 发票下载链接样式
.invoice-detail-page >>> .download-link
  color #1890ff
  cursor pointer
  font-weight 500
  transition all 0.3s
  display inline-flex
  align-items center
  gap 4px
  
.invoice-detail-page >>> .download-link:hover
  color #40a9ff
  text-decoration underline
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/StudentInvoiceDetail.vue